import React, { useState, useEffect } from "react";
import Auth from "@aws-amplify/auth";
import { useFormFields } from "../libs/hooksLibs";
import Log from "../utils/Log";
import { validateText } from "../utils/formUtils";
import ClientSignin from "../components/login/ClientSignin";
import { clientLoginRedirect } from "../actions/current";
import { useDispatch } from "react-redux";

//"Container" for sign in logic (ClientSignIn is for UI layout)
const SignIn = (props) => {
  const dispatch = useDispatch();
  const {
    fromBBClient,
    authError,
    showResetPassword,
    setShowResetPassword,
    scrollToSignup,
    router,
    isLoggedIn,
    curentUserName,
    handleSignout,
    windowWidth,
  } = props;

  const [fields, updateField] = useFormFields({
    username: "",
    password: "",
  });

  const [errorStateObject, updateInputErrorState] = useFormFields({
    username: false,
    password: false,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [generalErrorText, setGeneralError] = useState("");
  const [resendCode, setResendCode] = useState(false);

  useEffect(() => {
    if (authError) {
      setGeneralError(authError);
      const currentErrorObject = { username: true, password: true };
      updateInputErrorState(null, currentErrorObject);
    }
  }, [authError, updateInputErrorState]);

  function validateForm() {
    if (fields.username.length > 0 && fields.password.length > 0) {
      return true;
    }

    const currentErrorObject = { username: true, password: true };
    updateInputErrorState(null, currentErrorObject);
    return false;
  }

  function handleFieldChange(inputName, value) {
    if (validateText(value)) {
      updateInputErrorState(inputName, false);
    } else {
      updateInputErrorState(inputName, true);
    }
    setGeneralError("");

    if (inputName === "username") {
      updateField(inputName, value.replace(/\s+/g, ""));
    } else {
      updateField(inputName, value);
    }
  }

  function getErrorMessage(error) {
    let siginErrorMessage = error.message;

    if (siginErrorMessage.includes("confirmation")) {
      siginErrorMessage =
        "Your account still needs to be verified. A confirmation code has been sent to your email. Please click the link in the email to complete verification and activate your account.";
      setResendCode(true);
    } else if (
      siginErrorMessage.includes("PreAuthentication failed with error ")
    ) {
      let splitErrorMessage = siginErrorMessage.split(
        "PreAuthentication failed with error "
      );
      siginErrorMessage = splitErrorMessage[1];
    }

    return siginErrorMessage;
  }

  async function handleSubmit(event) {
    event.preventDefault();

    if (!validateForm()) {
      setGeneralError("Please fill out all required fields");
      return;
    }
    setIsLoading(true);
    try {
      if (fromBBClient) {
        await dispatch(clientLoginRedirect(fields.username, fields.password));
      } else {
        await Auth.signIn(fields.username, fields.password);
      }
      setIsLoading(false);
      //redirectToPreviousPage(props.router)
      return true;
    } catch (e) {
      setIsLoading(false);
      let message = getErrorMessage(e);
      setGeneralError(message);
    }

    const currentErrorObject = { username: true, password: true };
    updateInputErrorState(null, currentErrorObject);
    return false;
  }
  function handlePasswordReset() {
    setShowResetPassword(!showResetPassword);
    const expandable = document.getElementById("expandable");
    if(!expandable) {
      console.error("expandable element id not found");
      return;
    }

    if (windowWidth >= 768) {
      expandable.style.maxHeight = "243px";
    } else {
      expandable.style.maxHeight = "310px";
    }
  }

  async function resendVerificationCode() {
    Log.trace("resending verification code!");
    try {
      await Auth.resendSignUp(fields.username);
      setGeneralError(
        "A new code has been sent. Please check your email and click the link to activate your account."
      );
      Log.trace("code resent succesfully");
    } catch (err) {
      Log.error("error resending code: ", err);
    }
  }

  function togglePasswordVisiblity() {
    setPasswordShown(!passwordShown);
  }

  let productName = "generic"
  if(fromBBClient) {
    productName = sessionStorage.getItem("websocket-product")
  }

  const signinProps = {
    fields,
    errorStateObject,
    isLoading,
    generalErrorText,
    resendCode,
    showResetPassword,
    fromBBClient,
    authError,
    passwordShown,
    handlePasswordReset,
    resendVerificationCode,
    setShowResetPassword,
    handleSubmit,
    handleFieldChange,
    togglePasswordVisiblity,
    scrollToSignup,
    router,
    isLoggedIn,
    curentUserName,
    handleSignout,
    productName,
  };

  return <ClientSignin {...signinProps} />;
};

export default SignIn;
